module.exports = __webpack_public_path__ + "static/media/stream Bari video classes.b43935a6.svg";